/**
 * @param {number} count
 * @param {string} noun singular
 * @returns {string} e.g. `1 page`, `12 pages`
 */
function counted(count, noun) {
  return `${count} ${noun}${count === 1 ? '' : 's'}`;
}

/**
 * The confirmation shown after republishing a client's site.
 *
 * @param {import('../../shell/types/client.types.js').RepublishApiResponse} response
 * @returns {string}
 */
export function republishSummary({ pagesRendered, filesChanged }) {
  if (filesChanged === 0) {
    return pagesRendered === 1
      ? 'The 1 page is already up to date.'
      : `All ${counted(pagesRendered, 'page')} are already up to date.`;
  }
  return `Republished ${counted(pagesRendered, 'page')}: ${counted(filesChanged, 'file')} updated.`;
}
